<template>
  <div class="pt20">
    <h4>{{ id ? $t('admin.content.introduce.add.title.edit') : $t('admin.content.introduce.add.title.create') }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.introduce.add.form.title.label')" :colon="false">
          <a-input
            maxLength="20"
            allowClear
            :placeholder="$t('admin.content.introduce.add.form.title.placeholder')"
            v-decorator="['title', { rules: [{ required: true, message: $t('admin.content.introduce.add.form.title.required') }] }]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.introduce.add.form.content.label')" :colon="false">
          <div v-decorator="['content', { rules: [{ required: true, message: $t('admin.content.introduce.add.form.content.required') }] }]">
            <Editor v-model="contentValue"></Editor>
          </div>
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.content.introduce.add.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import Editor from '@/components/Editor/tinymce.vue'
import Upload from '@/components/upload/index.vue'

import {
  introduceSave,
  introduceDetail
} from '@/api/admin'
export default {
  components: {
    Editor,
    Upload
  },
  data() {
    return {
      id: undefined,
      contentValue: '',
      form: this.$form.createForm(this)
    }
  },
  watch: {
    contentValue: {
      handler(val) {
        this.form.setFieldsValue({
          content: val
        })
      }
    },
    $route() {
      this.columnId = this.$route.query.columnId
      this.getIntroduceDetail()
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    uploadData(data) {
      this.form.setFieldsValue({
        documentUrl: data[0].url
      })
    },
    async handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.id,
            columnId: this.columnId
          })
          introduceSave(data).then(res => {
            if (res.code == 200) {
              this.$message.success(this.$t('admin.content.introduce.add.messages.editSuccess'))
            }
          })
        }
      })
    },
    async getIntroduceDetail() {
      const res = await introduceDetail({ columnId: this.columnId })
      if (res.code === 200) {
        if (res.data.id === '0') {
          return
        }
        this.form.setFieldsValue({
          title: res.data.title,
          status: res.data.status
        })
        this.id = res.data.id
        this.contentValue = res.data.content
      }
    }
  },
  mounted() {
    this.columnId = this.$route.query.columnId
    this.getIntroduceDetail()
  }
}
</script>

<style lang="less" scoped>
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 20px;
  padding-bottom: 12px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
.back{
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #D6D6D6;
  img{
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form{
  .title{
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #EDEDED;
    &::before{
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6B738C;
    }
  }
  .list{
    display: flex;
    padding-right: 0px;
    .ant-form-item-label{
      label{
        color: #000000;
      }
    }
    .ant-form-item{
      width: 100%;
      padding-left: 6px;
      // display: flex;
      &:first-child{
        padding-left: 0;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix{
      position: absolute;
      img{
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div{
      position: relative;
      .ant-calendar-picker-input{
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D8DCE0;
      }

    }
    .ant-input,
    .ant-select{
      border-radius: 4px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select{
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
    .recommend{
      display: flex;
      .ant-radio-group{
        display: flex;
        align-items: center;
        .ant-radio-wrapper{
          margin-right: 20px;
          .ant-radio{
            color: #000000;
          }
        }
      }
      .ant-select{
        width: 107px;
        margin-left: 126px;
        border-radius: 4px;
        color: #000000;
        height: 35px;
      }
    }
    .ant-input-wrapper.ant-input-group{
      .ant-input{
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon{
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5E7A92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button{
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
</style>
